export default __webpack_public_path__ + "static/media/ic_bnb_30.4bcb5f1d.svg";